import BulletList from "../../../../Atoms/BulletList";

type OmissionsProps = {
  omissions: string[];
};

export default function Omissions({ omissions }: OmissionsProps) {
  return (
    <div>
      <h5 className="DetailTitle">Not included</h5>
      <BulletList items={omissions} />
    </div>
  );
}
